import type { ComponentType } from "react"

import {
  BanknoteIcon,
  CheckIcon,
  ClockIcon,
  FireIcon,
  type IconProps,
  LightningIcon,
  MoneyBagIcon,
  RefreshIcon,
  ReturnGlyphIcon,
  ShieldCheckIcon,
  SparkleIcon,
  StarIcon,
  TagIcon,
  TruckFastIcon,
  TruckIcon,
  WalletIcon,
} from "@/components/ui"

export type IconName =
  | "wallet"
  | "refresh"
  | "truck"
  | "truck-fast"
  | "shield-check"
  | "lightning"
  | "sparkle"
  | "star"
  | "tag"
  | "clock"
  | "fire"
  | "check"
  | "money-bag"
  | "banknote"
  | "return"

const ICONS: Record<IconName, ComponentType<IconProps>> = {
  wallet: WalletIcon,
  refresh: RefreshIcon,
  truck: TruckIcon,
  "truck-fast": TruckFastIcon,
  "shield-check": ShieldCheckIcon,
  lightning: LightningIcon,
  sparkle: SparkleIcon,
  star: StarIcon,
  tag: TagIcon,
  clock: ClockIcon,
  fire: FireIcon,
  check: CheckIcon,
  "money-bag": MoneyBagIcon,
  banknote: BanknoteIcon,
  return: ReturnGlyphIcon,
}

const NATURAL_SIZE: ReadonlySet<IconName> = new Set(["money-bag", "banknote", "return"])

export const Icon = ({ name, size }: { name: IconName; size?: number }) => {
  const Component = ICONS[name]
  return <Component size={NATURAL_SIZE.has(name) ? undefined : size} />
}
